/**
 * One chip of a list page's filter rail (Triage, Cases): the label with a
 * tick when selected, and the count. Triage and Cases each built this
 * button inline (kanban 445962e2); one component keeps the rails alike.
 */
import FilterTick from './FilterTick';
import styles from './QualityTriagePages.module.css';

export default function FilterChip({
  label,
  count,
  on,
  onClick,
  action,
  recordValue,
  value,
}: {
  label: string;
  count: number;
  on: boolean;
  onClick: () => void;
  /** The usage recorder names the chip by these, not by "All my items5":
   *  the count would otherwise make every day's chip a new step. */
  action: string;
  recordValue: 'show' | 'court' | 'stage';
  value: string;
}) {
  return (
    <button
      type="button"
      className={`${styles.filterChip} ${on ? styles.filterChipOn : ''}`}
      aria-pressed={on}
      data-action={action}
      data-record-value={recordValue}
      value={value}
      onClick={onClick}
    >
      <FilterTick on={on}>{label}</FilterTick>
      <span className={styles.filterCount}>{count}</span>
    </button>
  );
}
